import classNames from "classnames/bind";
import { Spinner } from "app/icons/navigation/Spinner";
import { TrashIcon, EditIcon, LayersIcon } from "../icons";
import { useClearStorage } from "../hooks/useClearStorage";
import { useDesignMode } from "../hooks/useDesignMode";
import styles from "./DevToolsActions.module.scss";

const cx = classNames.bind(styles);

type DevToolsActionsProps = {
	isViewerOpen: boolean;
	toggleViewer: () => void;
};

/**
 * The three dev actions rendered as left-aligned menu items.
 * The dataLayer viewer lifecycle is owned by the parent so the window survives popover close.
 */
export const DevToolsActions = ({ isViewerOpen, toggleViewer }: DevToolsActionsProps) => {
	const { clearStorage, isLoading } = useClearStorage();
	const { isActive: isDesignMode, toggle: toggleDesignMode } = useDesignMode();

	return (
		<div className={cx("dev-tools-actions")}>
			<button
				type="button"
				className={cx(
					"dev-tools-actions__action",
					"dev-tools-actions__action--destructive"
				)}
				onClick={clearStorage}
				disabled={isLoading}
			>
				{isLoading ? <Spinner size={15} /> : <TrashIcon aria-hidden="true" />}
				Vider cookies & local storage
			</button>

			<button
				type="button"
				className={cx("dev-tools-actions__action")}
				onClick={toggleDesignMode}
				aria-pressed={isDesignMode}
			>
				<EditIcon aria-hidden="true" />
				{isDesignMode ? "Désactiver le mode Design" : "Activer le mode Design"}
			</button>

			<button
				type="button"
				className={cx("dev-tools-actions__action")}
				onClick={toggleViewer}
				aria-pressed={isViewerOpen}
			>
				<LayersIcon aria-hidden="true" />
				{isViewerOpen ? "Fermer le DataLayer" : "Ouvrir le DataLayer"}
			</button>
		</div>
	);
};
